import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import { State as LtMaxPriceState, Update } from '~/LtMaxPrice/reducer';
import { Module, selectReferenceBasketVersions, State as PriceReferencingState } from '~/PriceReferencing';
import { Status } from '~/UI/SaveActivityIndicator/SaveActivityIndicator';

import ParametersPanel from './ParametersPanel';

interface State {
	ltMaxPrice: LtMaxPriceState;
	priceReferencing: PriceReferencingState;
}

interface OwnProps {
	group: UserProductGroup;
}

const selectUpdateStatus = memoizeOne((groupId: string, update: Update | null) => {
	if (update?.groupId !== groupId) {
		return null;
	}

	switch (update.state.name) {
		case 'scheduled':
		case 'fetching':
			return Status.saving;
		case 'updated':
			return Status.saved;
		case 'failed':
			return Status.failed;
		default:
			return null;
	}
});

const mapStateToProps = ({ ltMaxPrice, priceReferencing }: State, { group }: OwnProps) => ({
	updateStatus: selectUpdateStatus(group.id, ltMaxPrice.update),
	versions: selectReferenceBasketVersions(priceReferencing, Module.ltMaxPrice),
});

export default connect(mapStateToProps)(ParametersPanel);
